import {Brick, registerBrick} from 'olympe';

/**
 *
 */
export default class StopLoadingPopup extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input () is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */
    update(context, inputs, [forwardEvent]) {
        const popupElement = document.getElementById('loadingPopup017ed9020ff1be38dcf2');
        if (popupElement) {
            popupElement.remove();
        }
        forwardEvent();
    }
}

registerBrick('017ed9022883e8242683', StopLoadingPopup);
